import React, { createContext, useContext, useEffect, useState } from "react";
// import { rolesConfig } from '../Routes/rolesConfig';
import { getUserPermissions } from "../services/permissionServices";
import { companyID, getEmployeeLocalDetails } from "../auth";
import {
  checkSubscriptionExpiry,
  fetchCompanySubscription,
  isSubscriptionExpirySoon,
} from "../services/SubscriptionService";
import api from "../api/axios";

const RoleContext = createContext();

export const RoleProvider = ({ children, role }) => {
  const [rolesConfig, setRolesConfig] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const company_id = companyID();
  const role_id = localStorage.getItem("employee_role");

  function filterPages(data, filterKeys, role) {
    const filteredPages = {};

    filterKeys.forEach((key) => {
      if (data?.[role]?.pages?.[key]) {
        filteredPages[key] = data[role].pages[key];
      }
    });

    return {
      [role]: {
        pages: filteredPages,
      },
    };
  }

  useEffect(() => {
    const fetchData = async () => {
      const employeeDetails = getEmployeeLocalDetails();
      if (!company_id || !role_id) {
        setError("Missing company ID or role ID");
        setLoading(false);
        return;
      }

      setLoading(true);
      try {
        const employeeRole = await api.get(`employeeRole/${role_id}`);
        const subscription = await fetchCompanySubscription(company_id);
        console.log("subscription", subscription);
        const expired = checkSubscriptionExpiry(subscription);
        const isExpiredSoon = isSubscriptionExpirySoon(subscription);
        localStorage.setItem("isSubscriptionExpiredSoon", JSON.stringify(isExpiredSoon));
        localStorage.setItem("isSubscriptionExpired", JSON.stringify(expired));
        const data = await getUserPermissions(role_id, company_id , subscription[0]?.plan_id);
        if (expired) {
          setRolesConfig(
            filterPages(
              data.rolesConfig,
              ["subscriptions-plan"],
              employeeRole?.data[0].role_name
            )
          );
        } else if (employeeDetails?.onboarding_status === "PENDING") {
          setRolesConfig(
            filterPages(
              data.rolesConfig,
              [
                "onboarding-documents/:employee_id",
                "onboarding-policies/:employee_id",
                "onboarding",
              ],
              employeeRole?.data[0].role_name
            )
          );
        } else {
          setRolesConfig(data.rolesConfig || {});
        }
      } catch (err) {
        setError("Failed to fetch permissions or subscription status");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [company_id, role_id]);

  const permissions = rolesConfig[role] || {};

  return (
    <RoleContext.Provider
      value={{ role, permissions, rolesConfig, loading, error }}
    >
      {loading ? (
        <div className="d-flex justify-content-center align-items-center vh-100">
          <span className="text-primary" role="status">
            Loading...
          </span>
        </div>
      ) : (
        children
      )}
    </RoleContext.Provider>
  );
};

export const useRole = () => {
  const context = useContext(RoleContext);
  if (!context) {
    throw new Error("useRole must be used within a RoleProvider");
  }
  return context;
};
